<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    
    <Loader :show="loading" type="inline"></Loader>
    
    <div class="container margin_120" v-if="!loading">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div id="confirm" class="text-center">

                     <div class="svg-box" v-if="booking.status=='CONFIRMED'">
                        <svg class="circular green-stroke">
                            <circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10"/>
                        </svg>
                        <svg class="checkmark green-stroke">
                            <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-489.57,-205.679)">
                                <path class="checkmark__check" fill="none" d="M616.306,283.025L634.087,300.805L673.361,261.53"/>
                            </g>
                        </svg>
                    </div>

                    <div class="svg-box" v-if="booking.status=='FAILED_PAYMENT'">
                        <svg class="circular red-stroke">
                            <circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10"/>
                        </svg>
                        <svg class="cross red-stroke">
                            <g transform="matrix(0.79961,8.65821e-32,8.39584e-32,0.79961,-502.652,-204.518)">
                                <path class="first-line" d="M634.087,300.805L673.361,261.53" fill="none"/>
                            </g>
                            <g transform="matrix(-1.28587e-16,-0.79961,0.79961,-1.28587e-16,-204.752,543.031)">
                                <path class="second-line" d="M634.087,300.805L673.361,261.53"/>
                            </g>
                        </svg>
                    </div>

                    <div class="svg-box" v-if="booking.status=='AWAITING_PAYMENT'">
                        <svg class="circular yellow-stroke">
                            <circle class="path" cx="75" cy="75" r="50" fill="none" stroke-width="5" stroke-miterlimit="10"/>
                        </svg>
                        <svg class="alert-sign yellow-stroke">
                            <g transform="matrix(1,0,0,1,-615.516,-257.346)">
                                <g transform="matrix(0.56541,-0.56541,0.56541,0.56541,93.7153,495.69)">
                                    <path class="line" d="M634.087,300.805L673.361,261.53" fill="none"/>
                                </g>
                                <g transform="matrix(2.27612,-2.46519e-32,0,2.27612,-792.339,-404.147)">
                                    <circle class="dot" cx="621.52" cy="316.126" r="1.318" />
                                </g>
                            </g>
                        </svg>
                    </div>


                    <h2>{{title}}</h2>
                    <div class="instructions">
                        {{instructions}}
                    </div>
                    <p v-if="hasBankPayment" class="mt-3">
                        Para confirmarla tenés que realizar el pago mediante transferencia bancaria o depósito a la siguiente cuenta:<br>
                        Santander<br>
                        CC en Pesos Uruguayos<br>
                        Suc. 07<br>
                        000001047370<br>
                        Doctor Consultas SRL<br>
                        <br><br>
                        Una vez realizar el pago, por favor enviar el comprobante a hello@doctorconsultas.com
                    </p>
                    
                    <div class="row mt-4">
                        <div class="col-12">
                            <h3>Detalles de tu reserva</h3>
                            <h5 class="mt-4">Código</h5>
                            <h4>{{booking.code}}</h4>
                        </div>
                        
                        <div class="col-12 mt-2">
                            <h5><small>PROFESIONAL</small></h5>
                            <p>
                                {{booking.medic.fullname}}
                            </p>
                        </div>

                        <div class="col-12 mt-2">
                            <h5><small>Fecha y hora</small></h5>
                            <p>
                                {{ booking.timeslot.datetime | moment("dddd DD [de] MMMM") }} <br>
                                {{ booking.timeslot.datetime | moment("HH:mm") }} hrs.
                            </p>
                        </div>
                        <div class="col-12 mt-2">
                            <h5><small>Ubicación</small></h5>
                            <p v-if="booking.status=='CONFIRMED'">
                                {{booking.medicBusinessAddress.street}} {{booking.medicBusinessAddress.number}}
                            </p>
                            <p>
                                {{booking.medicBusinessAddress.locality.name}}, {{booking.medicBusinessAddress.locality.region.name}}
                            </p>
                        </div>
                        
                        
                    </div>
                    
                    <p class="text-secondary"> 
                        <br>
                        En instantes le llegará por mail, toda la información relacionada a su reserva.<br>
                        
                        Para ver todas tus reservas puedes ingresar a 
                        <router-link tag="a" :to="'/bookings'">Mis reservas</router-link>
                    </p>
                </div>
            </div>
        </div>
        <!-- /row -->
    </div>

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
//import { mapGetters, mapMutations } from 'vuex'

import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import Loader from '@/components/Loader';


export default {
    name: 'CheckoutResult',
    metaInfo() {
        return {
            title: this.title,
        }
	},
    components: {
        Navigation,
        Footer,
        Loader
    },
    data() {
        return {
            title:'asd',
            booking: {},
            loading:true,
            hasBankPayment:false,
        }
    },
    beforeMount(){
        if(this.$route.params.code){
            setTimeout(function () {
                this.loadBook();
            }.bind(this), 4000)
            setTimeout(function () {
                this.loadBook();
            }.bind(this), 6000)
        }
    },
    methods:{
        loadBook(){
			this.$apollo.query({
				query: gql`query getBooking($code: String!) {
					booking(code: $code){
                        id
                        code
                        status
                        timeslot{
                            datetime
                        }
                        medic{
                            fullname
                            phone
                        }
                        medicBusinessAddress{
                            street
                            number
                            comments
                            locality{
                                name
                                region{
                                    name
                                }
                            }
                        }
                        payments{
                            pay_method
                        }
					}
                }`,
                fetchPolicy: 'no-cache',
                variables:{
                    code: this.$route.params.code,
                },
			})
			.then((data) => {
                this.booking = data.data.booking;
                this.loading= false;
                this.setBookingStatus();
                this.findPaymentBank()
			});
        },
        setBookingStatus(){
            if( this.booking.status == 'AWAITING_PAYMENT' ){
                this.title= 'Pendiente de pago';
                this.instructions = 'Su reserva se encuentra pendiente de pago. ';
            }
            if( this.booking.status == 'FAILED_PAYMENT' ){
                this.title= 'Pago rechazado';
            }
            if( this.booking.status == 'CONFIRMED' ){
                this.title = 'Reserva confirmada';
            }

        },

        findPaymentBank(){
            this.hasBankPayment = false
            if(this.booking.payments.length>0){
               this.booking.payments.forEach( payment => {
                   if(payment.pay_method == 'BANK') this.hasBankPayment = true
               }) 
            }
            
        },


    }
    
}
</script>

<style scoped>
h3{
    font-size: 18px;
    margin: 0px;
}
h4{
    font-size: 20px;
    margin: 0px;
}
h5{
    font-size: 14px;
    text-transform: uppercase;
    margin: 0px;
}
p{
    color:#000;
    margin: 0px;
}

#confirm{
    max-width: 400px;
    margin: auto;
}






.svg-box {
    display:inline-block;
    position: relative;
    width:150px;
}

.green-stroke {
    stroke:#7CB342;
}

.red-stroke {
    stroke: #FF6245;
}

.yellow-stroke {
    stroke: #FFC107;
}


.circular circle.path {
    stroke-dasharray: 330;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    opacity: 0.4;
    animation: 0.7s draw-circle ease-out;
}

/*------- Checkmark ---------*/
.checkmark{
	stroke-width: 6.25;
    stroke-linecap: round;
	position:absolute;
    top: 56px;
    left: 49px;
    width: 52px;
    height: 40px;
}

.checkmark path {
    animation: 1s draw-check ease-out;
}

@keyframes draw-circle {
    0% {
        stroke-dasharray: 0,330;
        stroke-dashoffset: 0;
        opacity: 1;
    }

    80% {
        stroke-dasharray: 330,330;
        stroke-dashoffset: 0;
        opacity: 1;
    }

    100%{
        opacity: 0.4;
    }
}

@keyframes draw-check {
    0% {
        stroke-dasharray: 49,80;
        stroke-dashoffset: 48;
        opacity: 0;
    }

    50% {
        stroke-dasharray: 49,80;
        stroke-dashoffset: 48;
        opacity: 1;
    }

    100% {
        stroke-dasharray: 130,80;
        stroke-dashoffset: 48;
    }
}

/*---------- Cross ----------*/

.cross {
    stroke-width:6.25;
    stroke-linecap: round;
    position: absolute;
    top: 54px;
    left: 54px;
    width: 40px;
    height: 40px;
}

.cross .first-line {
    animation: 0.7s draw-first-line ease-out;
}

.cross .second-line {
    animation: 0.7s draw-second-line ease-out;
}

@keyframes draw-first-line {
    0% {
        stroke-dasharray: 0,56;
        stroke-dashoffset: 0;
    }

    50% {
        stroke-dasharray: 0,56;
        stroke-dashoffset: 0;
    }

    100% {
        stroke-dasharray: 56,330;
        stroke-dashoffset: 0;
    }
}

@keyframes draw-second-line {
    0% {
        stroke-dasharray: 0,55;
        stroke-dashoffset: 1;
    }

    50% {
        stroke-dasharray: 0,55;
        stroke-dashoffset: 1;
    }

    100% {
        stroke-dasharray: 55,0;
        stroke-dashoffset: 70;
    }
}

.alert-sign {
    stroke-width:6.25;
    stroke-linecap: round;
    position: absolute;
    top: 40px;
    left: 68px;
    width: 15px;
    height: 70px;
    animation: 0.5s alert-sign-bounce cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.alert-sign .dot {
    stroke:none;
    fill: #FFC107;
}

@keyframes alert-sign-bounce {
    0% {
        transform: scale(0);
        opacity: 0;
    }

    50% {
        transform: scale(0);
        opacity: 1;
    }

    100% {
        transform: scale(1);
    }
}
</style>
